import { render, staticRenderFns } from "./WeChatLoginBtn.vue?vue&type=template&id=62640956&"
import script from "./WeChatLoginBtn.vue?vue&type=script&lang=js&"
export * from "./WeChatLoginBtn.vue?vue&type=script&lang=js&"
import style0 from "./WeChatLoginBtn.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports